import { render, staticRenderFns } from "./AttachmentFileUploader.vue?vue&type=template&id=0f5d4426&"
import script from "./AttachmentFileUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports